module.exports = __webpack_public_path__ + "static/media/SWSCRC1-38.847eb692.mp3";